// src/common/MessageBox.js
import React from 'react';

const MessageBox = ({ message, type, onClose }) => {
    if (!message) return null;

    let bgColor, textColor, borderColor;
    switch (type) {
        case 'success':
            bgColor = 'bg-green-100';
            textColor = 'text-green-800';
            borderColor = 'border-green-400';
            break;
        case 'error':
            bgColor = 'bg-red-100';
            textColor = 'text-red-800';
            borderColor = 'border-red-400';
            break;
        case 'warning':
            bgColor = 'bg-yellow-100';
            textColor = 'text-yellow-800';
            borderColor = 'border-yellow-400';
            break;
        case 'info':
            bgColor = 'bg-blue-100';
            textColor = 'text-blue-800';
            borderColor = 'border-blue-400';
            break;
        default:
            bgColor = 'bg-gray-100';
            textColor = 'text-gray-800';
            borderColor = 'border-gray-400';
    }

    return (
        <div className={`fixed top-4 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 transform scale-100 ${bgColor} ${textColor} border ${borderColor}`}>
            <div className="flex justify-between items-center">
                <span className="font-semibold">{message}</span>
                <button onClick={onClose} className="ml-4 text-lg font-bold">
                    &times;
                </button>
            </div>
        </div>
    );
};

export default MessageBox;
